<template>
  <div class="exel-download">
    <form @submit.prevent="submitForm" class="exel-form">
      <div class="exel-date-input">
        <datepicker v-model="startDate" format="yyyy-MM-dd" :clearable="true" placeholder="Дата начала" class="datepick-input"></datepicker>
      </div>
      <div class="exel-date-input">
        <datepicker v-model="endDate" format="yyyy-MM-dd" :clearable="true" placeholder="Дата завершения" class="datepick-input"></datepicker>
      </div>
      <button class="submit-exel" type="submit" :disabled="!isDownload" >Скачать Excel</button>
    </form>
  </div>
</template>

<script>
import Datepicker from 'vue3-datepicker';
import { ref,computed } from 'vue';
import ApiConnector from '@/backend/apiModels/userApi'

export default {
  name: 'ExcelGenerator',
  props:['form'],
  components: {
    Datepicker,
  },

  setup() {
    const startDate = ref(null);
    const endDate = ref(null);
    const api = new ApiConnector()

    const form = computed(()=>{props.form})

    const isDownload = computed(()=>{
      return startDate.value && endDate.value
    })

    const submitForm = async () => {
      
      // try {
      //   const params = {date_to:endDate.value, date_from:startDate.value}
      //   const response = await api.getFile('generate_excel',params)

      //   // Создайте объект Blob с данными файла
      //   const blob = new Blob([response.data]);

      //   // Создайте ссылку на скачивание файла
      //   const url = window.URL.createObjectURL(blob);

      //   // Создайте элемент "a" для скачивания файла
      //   const a = document.createElement('a');
      //   a.style.display = 'none';
      //   a.href = url;
      //   a.download = 'output.xlsx'; // Установите имя файла

      //   // Добавьте элемент "a" в DOM и нажмите на него
      //   document.body.appendChild(a);
      //   a.click();

      //   // Очистите URL и уберите элемент "a"
      //   window.URL.revokeObjectURL(url);
      //   document.body.removeChild(a);
        
      // } catch (error) {
      //   console.error('Ошибка при генерации Excel файла:', error);
      // }
    };

    return {
      startDate,
      endDate,
      submitForm,
      isDownload
    };
  },
};
</script>

<style scoped>
.exel-download{
  display: flex;
  align-items: center;
  
}
.exel-form{
  margin-top: 4px;
  padding: 2px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.exel-date-input{
/*  margin-top: 2px;*/
  margin-bottom: 2px;
}

.submit-exel{
  margin-top: 5px;
}

</style>
